module.exports = __webpack_public_path__ + "img/chuantou.f1921de8.svg";